import { Button, Chip, makeStyles, Paper, Tooltip } from "@material-ui/core";
import React, { useCallback } from "react";

import { BoxOwner } from "../../../../../dtos/box";
import { EnrollBiometricsButton } from "../../../../shared/EnrollBiometricsButton";
import { BoxFeature } from "../types";

import { useRemoveOwner } from "./useDeleteOwner";

const useStyles = makeStyles((theme) => ({
    card: {
        padding: "20px",
        alignSelf: "flex-start",
        width: "60%",
        "& label": {
            marginRight: "5px",
        },
    },
    inactiveCard: {
        color: theme.palette.grey[400] + " !important",
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px",
    },
    nameRow: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    inactiveChip: {
        height: "22px",
    },
    cardButtons: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
}));

interface Props {
    owner: BoxOwner;
    boxId: number;
    onOwnerRemoved: () => void;
    onSetOwnerIdToEnroll: (id: number) => void;
    ownerDeleteFeature: BoxFeature;
    ownerEnrollFeature: BoxFeature;
}

export function BoxOwnerCard({
    owner,
    boxId,
    onOwnerRemoved,
    onSetOwnerIdToEnroll,
    ownerDeleteFeature,
    ownerEnrollFeature,
}: Props) {
    const { removeOwner, loading } = useRemoveOwner(boxId);

    const handleRemoveOwner = useCallback(() => {
        removeOwner(owner.id, onOwnerRemoved);
    }, [owner, removeOwner, onOwnerRemoved]);

    const classes = useStyles();

    return (
        <Paper className={`${classes.card} ${owner.isInactive ? classes.inactiveCard : ""}`}>
            <div className={classes.cardHeader}>
                <div className={classes.nameRow}>
                    <h3>{owner.fullName}</h3>
                    {owner.isInactive && (
                        <Chip label="Inactive" size="small" className={classes.inactiveChip} />
                    )}
                </div>
                <div className={classes.cardButtons}>
                    <Tooltip title={owner.isInactive ? "Deactivated Owner" : ownerEnrollFeature.reason}>
                        <span>
                            <EnrollBiometricsButton
                                user={owner}
                                onSetUserIdToEnroll={onSetOwnerIdToEnroll}
                                disabled={owner.isInactive || !ownerEnrollFeature.enabled}
                            />
                        </span>
                    </Tooltip>

                    <Tooltip title={ownerDeleteFeature.reason}>
                        <span>
                            <Button
                                variant="outlined"
                                color="secondary"
                                style={{ display: "inline-block" }}
                                onClick={handleRemoveOwner}
                                disabled={!ownerDeleteFeature.enabled || loading}
                            >
                                {loading ? "Deleting" : "Delete"}
                            </Button>
                        </span>
                    </Tooltip>
                </div>
            </div>
            <div>
                <label><b>Phone:</b></label>
                {owner.phone}
            </div>
            <div>
                <label><b>Email:</b></label>
                {owner.email}
            </div>
            <div>
                <label><b>Address:</b></label>
                {owner.address}
            </div>
        </Paper>
    );
}
